

import { mapActions, mapState } from 'vuex'

import RatingStarsInfoLeft from '../RatingStarsInfoLeft'
export default {
  name: 'InfoLeft',
  components: {
    RatingStarsInfoLeft,
  },
  props: {
    averageScore: {
      type: Number,
      required: true
    },
    totalReviews: {
      type: Number,
      required: true
    },
    totalQuestions: {
      type: Number,
      required: true
    },
    fullWidth: {
      type: Boolean,
      default: () => false
    }
  },
  computed: {
    ...mapState({
      product: state => state.ui.product
    })
  },
  methods: {
    ...mapActions({
      showReviewsSidebar: 'ui/showProductReviewsSidebar',
      showQuestionsSidebar: 'ui/showProductQuestionsSidebar',
    }),
  }
}
